import { UploadFile } from 'antd';

import { ApiError } from './api-error';
import { BaseApi } from './baseApi';

interface ExportCsvPayload {
    filterFlexible?: string;
    orderBy?: string[];
    columns?: string[];
}

export class ScheduleApi extends BaseApi {
    constructor(tokenProvider: () => Promise<string>) {
        super(BaseApi.getBaseUrl('SCHEDULE_API_URL'), tokenProvider);
    }

    private async exportCsv(endpoint: string, payload: ExportCsvPayload): Promise<void> {
        const response = await this.post(endpoint, payload);
        await this.saveDownloadedFile(response);
    }

    async exportScheduleItemsToCsv(payload: ExportCsvPayload): Promise<void> {
        await this.exportCsv('/schedule-item/export/csv', payload);
    }

    async exportTasksToCsv(payload: ExportCsvPayload): Promise<void> {
        await this.exportCsv('/task/export/csv', payload);
    }

    async getImportScheduleItemsCsvTemplate(): Promise<void> {
        const response = await this.get('/schedule-item/import/csv-template');

        await this.saveDownloadedFile(response);
    }

    async importScheduleItemsFromCsv({
        projectId,
        phaseId,
        file,
    }: {
        projectId: string;
        phaseId: number;
        file: UploadFile;
    }): Promise<void> {
        const formData = new FormData();
        formData.append('project', projectId);
        formData.append('phase', phaseId.toString());
        formData.append('compression', 'none');

        const fileObj = file.originFileObj;

        if (!fileObj) {
            throw new ApiError('WRONG_PARAMETER', [{ message: 'No file found in the upload file object.' }]);
        }

        formData.append('file', fileObj, file.name);

        await this.post('/schedule-item/import/csv', formData);
    }

    async getImportTasksCsvTemplate(): Promise<void> {
        const response = await this.get('/task/import/csv-template');

        await this.saveDownloadedFile(response);
    }

    async importTasksFromCsv({
        projectId,
        phaseId,
        scheduleItemId,
        file,
    }: {
        projectId: string;
        phaseId: number;
        scheduleItemId: string;
        file: UploadFile;
    }): Promise<void> {
        const formData = new FormData();
        formData.append('project', projectId);
        formData.append('phase', phaseId.toString());
        if (scheduleItemId) {
            formData.append('item', scheduleItemId);
        }

        formData.append('compression', 'none');

        const fileObj = file.originFileObj;

        if (!fileObj) {
            throw new ApiError('WRONG_PARAMETER', [{ message: 'No file found in the upload file object.' }]);
        }

        formData.append('file', fileObj, file.name);

        await this.post('/task/import/csv', formData);
    }
}
